import { Component } from '@angular/core';

import { CapabilitiesService } from '../shared/shared-context/capabilities.service';

@Component({
    selector: 'ohp-first-run-wrapper',
    templateUrl: './first-run-wrapper.component.html'
})
export class FirstRunWrapperComponent {
    public readonly firstRunReactEnabled: boolean;

    constructor(
        private readonly capabilitiesService: CapabilitiesService
    ) {
        this.firstRunReactEnabled = this.capabilitiesService.capabilities.firstRunReactEnabled;
    }
}
